import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_sc_file_select = _resolveComponent("sc-file-select");
    const _component_el_dialog = _resolveComponent("el-dialog");
    return _openBlock(), _createBlock(_component_el_dialog, {
        "append-to-body": "",
        title: "上传图片",
        modelValue: $data.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.visible = $event),
        "align-center": "",
        width: 1100,
        "destroy-on-close": "",
        onClosed: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit('closed'))
    }, {
        default: _withCtx(()=>[
                _createVNode(_component_sc_file_select, {
                    modelValue: $data.file,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.file = $event),
                    multiple: $props.multiple,
                    hideUpload: $props.hideUpload,
                    max: $props.max,
                    onSubmit: $options.submit
                }, null, 8, [
                    "modelValue",
                    "multiple",
                    "hideUpload",
                    "max",
                    "onSubmit"
                ])
            ]),
        _: 1
    }, 8, [
        "modelValue"
    ]);
}
